<template>
    <div>
        <div class="container separator-border-top-line mb-10">
            <div class="grid grid-cols-12 base-responsive-gap">
                <div class="col-span-12 sm:col-span-6 md:col-span-7">
                    <h2 class="header-2">{{ title }}</h2>
                    <div v-if="lead" class="lead mt-4 sm:mt-8 sm:mb-12" v-html="lead"></div>
                </div>
            </div>
        </div>

        <CardCarousel
            v-if="items.length"
            ref="cardCarousel"
            :items="items"
            :component-id="generatedComponentId"
            large
            :is-initialized="activeSlideIndex !== null"
            :type="`tab-type-${carouselType}`"
            :programmatic-active-slide-index="activeSlideIndex"
            should-update-active-index-on-slide-change
            @update-active-index="onUpdateActiveIndex"
        />

        <Transition name="fade" mode="out-in">
            <div
                v-if="activePanel"
                :id="`tab-content-${generatedComponentId}-${activeSlideIndex + 1}`"
                :key="activeSlideIndex"
                class="container pb-4 pt-8 lg:pt-12"
                role="region"
                :aria-labelledby="`tab-header-${generatedComponentId}-${activeSlideIndex + 1}`"
            >
                <div class="grid grid-cols-12 gap-y-4 lg:gap-x-7">
                    <div class="panel__content col-span-12 md:col-span-7 md:px-8 container-overflow-forbidden">
                        <h3 class="header-3">{{ activePanel.name }}</h3>
                        <div class="mt-4 wysiwyg-content" v-html="activePanel.description"></div>
                    </div>
                    <div class="panel__image col-span-12 md:col-span-5 row-span-2">
                        <div class="mt-2 relative aspect-w-16 aspect-h-9">
                            <img
                                :src="$getMediaImage(activePanel.media, 'lead')"
                                :alt="`${title} ${$t('generic.gallery_image_alt_text')} ${activePanel}`"
                                class="absolute w-full h-full object-cover object-center sm:object-left md:object-center base-responsive-rounding"
                            />
                        </div>
                    </div>

                    <div
                        v-if="activePanel.label_cta && activePanel.details_cta_url_primary"
                        class="panel__cta-container col-span-12 md:col-span-7 md:px-8"
                    >
                        <div class="mt-4">
                            <Button
                                :to="activePanel.details_cta_url_primary"
                                target="_blank"
                                :label="activePanel.label_cta"
                                tabindex="1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import { nanoid } from 'nanoid';
import CardCarousel from '@/components/Carousels/CardCarousel/CardCarousel.vue';

export default {
    name: 'ServiceGroupBlock',
    components: {
        CardCarousel,
    },
    props: {
        // carouselType === 1: text goes onto image, blue bg opacity overlay on hover & active state
        // carouselType === 2: text goes under image, underlined text on hover & active state
        carouselType: {
            type: Number,
            required: false,
            default: 1,
            validator(value) {
                if (![1, 2].includes(value)) {
                    throw new Error('ServiceGroupBlock can either have carouselType 1 or carouselType 2');
                }
                return true;
            },
        },
        title: {
            type: String,
            required: true,
        },
        lead: {
            type: String,
            required: false,
            default: null,
        },
        items: {
            type: Array,
            required: true,
        },
        activeItemHash: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            activeSlideIndex: null,
            generatedComponentId: nanoid(),
            // $currentActivePanel: null,
        };
    },
    computed: {
        activePanel() {
            return this.items[this.activeSlideIndex];
        },
    },
    watch: {
        activeItemHash(value) {
            if (!value) {
                return null;
            }

            const itemWithRouteHash = this.items.find((x) => {
                return x.anchor && x.anchor.replace(/^#/, '') === value.replace(/^#/, '');
            });

            if (itemWithRouteHash) {
                const index = this.items.indexOf(itemWithRouteHash);
                this.onUpdateActiveIndex(index);
            }
        },
    },
    methods: {
        onUpdateActiveIndex(index) {
            this.activeSlideIndex = index;

            // if (this.$currentActivePanel && this.$currentActivePanel.querySelector('a')) {
            //     console.log('do nothing');
            // } else {
            //     setTimeout(() => {
            //         this.$currentActivePanel = document.getElementById(
            //             `tab-content-${this.generatedComponentId}-${index + 1}`
            //         );
            //
            //         // const anchorsInsideCurrentActivePanel = Array.from(this.$currentActivePanel.querySelectorAll('a'));
            //         //
            //         // anchorsInsideCurrentActivePanel[0].addEventListener('keydown', (e) => {
            //         //     if (e.shiftKey && e.keyCode === 9) {
            //         //         e.preventDefault();
            //         //         document.getElementById(`tab-header-${this.generatedComponentId}-${index + 1}`).click();
            //         //     }
            //         // });
            //         //
            //         // anchorsInsideCurrentActivePanel[anchorsInsideCurrentActivePanel.length - 1].addEventListener(
            //         //     'keydown',
            //         //     (e) => {
            //         //         console.log('key up');
            //         //         if (e.keyCode === 9) {
            //         //             e.preventDefault();
            //         //             console.log('focusing ', `tab-header-${this.generatedComponentId}-${index + 2}`);
            //         //             document.getElementById(`tab-header-${this.generatedComponentId}-${index + 2}`).click();
            //         //         }
            //         //     }
            //         // );
            //     }, 100);
            // }
        },
    },
};
</script>

<style scoped></style>
